enum ProductMigrationLogState {
    Information = "INFORMATION",
    Warning = "WARNING",
    Error = "ERROR"
}
export default ProductMigrationLogState